import React from "react";
import clsx from "clsx";
import { Box, MenuItem, SelectField } from "@curves/ui-base";
import { parseDate } from "@util/moment";
import { isEmpty } from "@util/utils";

// 量測資訊比較外框元件
const InBodyInterviewMeasureCompareBox = props => {
	const { itemKey, formatCell, formatCompare, formatMultipleCell, datumData = [], compareData = [], styles = {}, selectedItem, setSelectedItem, measureDateOptions = [] } = props;

	const handleDateOnChange = (_e, _n, value) => {
		setSelectedItem(value);
	};
	
	return (
		<React.Fragment>
			<Box className={clsx("item", "text-center")} style={{ width: "30%", ...styles }}>
				{formatCell ? formatCell(datumData[itemKey], datumData, { key: itemKey }) : datumData[itemKey]}
			</Box>
			<Box className={clsx("item", "text-center")} style={{ width: "220px", ...styles }}>
				{formatCompare
					? formatCompare({
							datumDataValue: datumData[itemKey],
							compareDataValue: compareData[itemKey],
							itemKey: itemKey,
							datumData: datumData,
							compareData: compareData,
					  })
					: ""}
			</Box>
			<Box className={clsx("item", "text-center", "right-divider")} style={{ width: "30%", ...styles }}>
				{itemKey === "measureDate" && !isEmpty(measureDateOptions) ? (
					<SelectField key={measureDateOptions} defaultValue={selectedItem} onChange={handleDateOnChange}>
						{measureDateOptions.map(({ text, value }) => {
							const dateString = parseDate(text);
							return (
								<MenuItem key={value} value={value}>
									{dateString}
								</MenuItem>
							);
						})}
					</SelectField>
				) : formatMultipleCell ? (
					formatMultipleCell(compareData[itemKey], compareData, { key: itemKey })
				) : formatCell ? (
					formatCell(compareData[itemKey], compareData, { key: itemKey })
				) : (
					compareData[itemKey]
				)}
			</Box>
		</React.Fragment>
	);
};

export default InBodyInterviewMeasureCompareBox;
